import { useState } from 'react';
import Tab from 'components/common/Tab/Tab';
import Tabs from 'components/common/Tabs/Tabs';
import TabList from 'components/common/TabList/TabList';
import TabContents from 'components/common/TabContents/TabContents';
import TabContent from 'components/common/TabContent/TabContent';

/**
 * Examples of Scalyr's Tab component
 */

function TabsExamplePage(): JSX.Element {
  const [selectedTab, setSelectedTab] = useState('Tab 1');

  return (
    <section id="tabs" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Tabs</h1>

      <Tabs id="TabsExampleId" activeTab={selectedTab} onSelect={(tab) => setSelectedTab(tab)} mountOnEnter={true}>
        <TabList className="TabList__Tabs">
          <Tab eventKey="Tab 1">Tab 1</Tab>
          <Tab eventKey="Tab 2">Tab 2</Tab>
          <Tab eventKey="Tab 3">Tab 3</Tab>
        </TabList>
        <TabContents>
          <TabContent eventKey="Tab 1">
            <div className="ExamplesPage__TabContent">
              <p>Tab 1 content</p>
            </div>
          </TabContent>
          <TabContent eventKey="Tab 2">
            <div className="ExamplesPage__TabContent">
              <p>Tab 2 content</p>
            </div>
          </TabContent>
          <TabContent eventKey="Tab 3">
            <div className="ExamplesPage__TabContent">
              <p>Tab 3 content</p>
            </div>
          </TabContent>
        </TabContents>
      </Tabs>
    </section>
  );
}
export default TabsExamplePage;
